export default __webpack_public_path__ + "static/media/animated-truck-healthy.37623d6a.gif";